module.exports = __webpack_public_path__ + "static/media/kinedu-educators-pt.be26366e.svg";